import type { SVGProps } from 'react';
const SvgRightCaret = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 8 12" {...props}>
    <path d="M0.7925 2.5375L4.6725 6.4175L0.7925 10.2975C0.4025 10.6875 0.4025 11.3175 0.7925 11.7075C1.1825 12.0975 1.8125 12.0975 2.2025 11.7075L6.7925 7.1175C7.1825 6.7275 7.1825 6.0975 6.7925 5.7075L2.2025 1.1175C1.8125 0.727501 1.1825 0.727501 0.7925 1.1175C0.4125 1.5075 0.4025 2.1475 0.7925 2.5375Z" />
  </svg>
);
export default SvgRightCaret;
